import React__default from 'react';
import { KubernetesStructuredMetadataTableDrawer } from '../KubernetesDrawer/KubernetesStructuredMetadataTableDrawer.esm.js';
import '../KubernetesDrawer/KubernetesDrawer.esm.js';
import '@backstage/core-components';
import '@material-ui/core/FormControlLabel';
import '@material-ui/core/Switch';
import 'js-yaml';

const HorizontalPodAutoscalerDrawer = (props) => {
  const { hpa, expanded, children } = props;
  const specCpuUtil = hpa?.spec?.metrics?.find(
    (metric) => metric.type === "Resource" && metric.resource?.name === "cpu"
  )?.resource?.target.averageUtilization;
  const cpuUtil = hpa?.status?.currentMetrics?.find(
    (metric) => metric.type === "Resource" && metric.resource?.name === "cpu"
  )?.resource?.current.averageUtilization;
  return /* @__PURE__ */ React__default.createElement(
    KubernetesStructuredMetadataTableDrawer,
    {
      kind: "HorizontalPodAutoscaler",
      object: hpa,
      expanded,
      renderObject: (hpaObject) => {
        return {
          targetCPUUtilizationPercentage: specCpuUtil,
          currentCPUUtilizationPercentage: cpuUtil,
          minReplicas: hpaObject.spec?.minReplicas,
          maxReplicas: hpaObject.spec?.maxReplicas,
          currentReplicas: hpaObject.status?.currentReplicas,
          desiredReplicas: hpaObject.status?.desiredReplicas,
          lastScaleTime: hpa?.status?.lastScaleTime
        };
      }
    },
    children
  );
};

export { HorizontalPodAutoscalerDrawer };
//# sourceMappingURL=HorizontalPodAutoscalerDrawer.esm.js.map
